<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Import Lesson Plans</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete rounded :items="ay_list" v-model="ay" item-text="ay" item-value="id"
                        label="Academic Year" dense outlined placeholder="Select Academic Year"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete rounded :items="course_list" v-model="course" item-text="course" item-value="id"
                        label="Course/Subject" dense outlined placeholder="Select Course/Subject"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-checkbox v-model="default_approve" label="Default Approve Lesson Plan..?"></v-checkbox> </v-col>
            </v-row>

            <v-row justify="center" align="center" v-if="ay != null && course!=null">
                <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                    <v-file-input placeholder="CSV of student data" prepend-icon="mdi-file" label="Student Data"
                        show-size flat rounded outlined dense v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                    <a
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/import_course_plans.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
                            class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                            Download import CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-col>
            </v-row>

            <v-row justify="center" align="center">
                <!-- <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn> -->
                <v-btn class="button" @click="submitFile">Submit</v-btn>
            </v-row>

            <!-- shiv new code -->
            <!-- <v-col cols="12" sm="12" md="12">
              <template v-if="load == false">
                  <v-simple-table class="mytable">
                      <template v-slot:default>
                          <thead>
                              <tr>
                                  <th class="text-left">GR No</th>
                                  <th class="text-left">Bruch 1</th>
                                  <th class="text-left">Term Fee 1</th>
                                  <th class="text-left">Exam Fee 1</th>
                                  <th class="text-left">Robotics 1</th>
                                  <th class="text-left">Add fees Components</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>VVEPP00010</td>
                                  <td>400</td>
                                  <td>400</td>
                                  <td>300</td>
                                  <td>100</td>
                                  <td></td>
                              </tr>
                              <tr>
                                  <td class="mandatory">Mandatory</td>
                                  <td class="mandatory">Mandatory</td>
                                  <td class="mandatory">Mandatory</td>
                                  <td class="mandatory">Mandatory</td>
                                  <td class="mandatory">Mandatory</td>
                                  <td class="mandatory">Mandatory (If you add)</td>
                              </tr>
                          </tbody>
                      </template>
                  </v-simple-table>
              </template>
          </v-col> -->
            <!-- shiv code end -->

            <span v-if="show_scuuess_table != ''">
                <!-- <v-col cols="12" sm="12" md="12" v-if="statuslist.statuslist[0].faillist != ''">
                  <v-toolbar flat dense class="toolbar">
                      <v-toolbar-title>Failed Students Data</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                  </v-toolbar>
                  <download-excel class="ma-2 no-display" color="primary" dark :data="statuslist.statuslist[0].faillist" :fields="xls_header1" worksheet="Failed Data" name="Failed_Data.xls">
                      <v-btn class="ma-2 no-display" tile outlined color="success">
                          <v-icon left>mdi-file-excel</v-icon> Excel
                          <v-icon right>mdi-download</v-icon>
                      </v-btn>
                  </download-excel>
                  <template>
                      <v-data-table dense :headers="headers1" :items="statuslist.statuslist[0].faillist" sort-by class="elevation-1 mytable" :search="search"></v-data-table>
                  </template>
              </v-col> -->

                <v-col cols="12" sm="12" md="12" v-if="success_list != ''">
                    <template>
                        <v-data-table dense :headers="headers" :items="success_list" sort-by class="elevation-1 mytable"
                            :search="search">
                            <template v-slot:top>
                                <v-toolbar flat dense class="toolbar">
                                    <v-toolbar-title>Success Data</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-toolbar flat dense color="white" align="center" justify="center">
                                    <download-excel class="ma-2 no-display" color="primary" dark :data="success_list"
                                        :fields="xls_header" worksheet="Success_Data" name="Success_Data.xls">
                                        <v-btn class="ma-2 no-display" tile outlined color="success">
                                            <v-icon left>mdi-file-excel</v-icon> Excel
                                            <v-icon right>mdi-download</v-icon>
                                        </v-btn>
                                    </download-excel>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </template>
                </v-col>
            </span>
        </v-card>
        <div class="text-center">
            <v-dialog v-model="output_load" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
  import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      data() {
          return {
              file: null,default_approve: true,show_scuuess_table:false,success_list:[],
              statuslist: [],
              load: false,
            //   extraBreadcrumbItems: [


            //   ],
            //   breadcrumbClass: "breadcrumb-style1",
              loading3: false,
              search: "",
              snackbar: false,
              snackbar_msg: "",
              color: "",
              snackbar: false,
              course_list: [],
              ay_list: [],
              ay: null,
              list_display: null,
              course: null,
              xls_header: {
                  SR_No: "sr.no",
                  PRN_No: "grno",
                  Status: "status",
                  Amount: "amount",
              },
              headers: [
                  { text: "Sr.NO", value: "count" },
                  { text: "Lecture No", value: "lesson_no" },
                  { text: "Unit", value: "unit" },
                  { text: "Topic", value: "topic" },
                  { text: "Learning Outcomes", value: "learning_outcomes" },
                  { text: "Instructional Tool Refernences", value: "instructional_tool_refernences" },
                  { text: "Pedagogy", value: "pedagogy" },
                  { text: "Activity/Assignment/Research", value: "activity_assignment_research" },
                  { text: "Assessment", value: "assessment" },
                  { text: "Exam", value: "exam_name" },
              ],
              xls_header1: {
                  PRN_No: "grno",
                  Status: "status",
                  Remark: "remark",
              },
              headers1: [
                  { text: "PRN No", value: "grno" },
                  { text: "Status", value: "status" },
                  { text: "Reason", value: "remark" },
              ],
              output_load: false,
          };
      },

      methods: {
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          submitFile() {
              this.load = true;
              if (this.file == null) {
                  alert("Please select the file!");
              } else {
                  this.output_load = true;
                  let formData = new FormData();
                  //console.log(this.file.size)
                  formData.append("file", this.file);
                  formData.append("course", this.course);
                  formData.append("ay", this.ay);
                  formData.append("isapproved", this.default_approve);

                  //console.log(formData)
                  axios
                      .post("LessonPlanning/saveImportCoursePlan", formData, {
                          headers: {
                              "Content-Type": "multipart/form-data",
                          },
                      })
                      .then((res) => {
                          if (res.data.flag == "NO") {
                              this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                          } else {
                              this.success_list = res.data.statuslist;
                             this.show_scuuess_table = true;
                              this.output_load = false;
                              this.showSnackbar("#4caf50", "Data Imported Successfully..."); // show snackbar on success
                          }
                      })
                      .catch(function () {
                          console.log("FAILURE!!");
                          this.output_load = false;
                      })
                      .finally(() => {
                          this.output_load = false;
                      });
                  //     }
              }
          }, //end of the fuction

          /*
      Handles a change on the file upload
    */
      },
      mounted() {
          axios
              .post("/LessonPlanning/importCoursePlan")
              .then((res) => {
                  this.ay = res.data.cay;
                  this.ay_list = res.data.ay_list;
                  this.course_list = res.data.course_list;
              })
              .catch((error) => {
                  this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
              })
              .finally(() => {});
      },
  };
</script>
<style scoped>
  .downbtn {
      float: right;
  }
  .mytable2 /deep/ thead th {
      background: #0f2027; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }

  /* new css */
  table,
  th {
      padding: 10px;
      border: 1px solid rgb(206, 200, 200);
      border-collapse: collapse;
      background: #0f2027; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }
  .mandatory {
      color: red;
  }
</style>
